import React from 'react';
import './ContactSection.css';
import { useLanguage } from '../hooks/useLanguage';

const ContactSection = () => {
  const { t } = useLanguage();

  return (
    <section className="contact" id="contact">
      <div className="contact-content">
        <h2 className="section-heading">{t.contact.title}</h2>
        <div className="contact-info">
          <p>
            {t.contact.email}:{' '}
            <a href="mailto:zenzz@hotmail.ch">zenzz@hotmail.ch</a>
          </p>
          <p>
            {t.contact.linkedin}:{' '}
            <a href="https://www.linkedin.com/in/zen-zalapski-7a35052b9/" target="_blank" rel="noopener noreferrer">Zen Zalapski</a>
          </p>
          <p>
            {t.contact.github}:{' '}
            <a href="https://github.com/HollowWeb" target="_blank" rel="noopener noreferrer">HollowWeb</a>
          </p>
          <p>{t.contact.location}: {t.contact.locationValue}</p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
